<template>
  <div v-if="options">
    <div class="d-flex align-items-center">
      <div>
        <h4 class="mb-0">
          {{ $t(options.title) }}
        </h4>
        <span>{{ $t(options.subtitle) }}</span>
      </div>
    </div>

    <!-- collapse -->
    <app-collapse
      id="faq-payment-qna"
      accordion
      type="margin"
      class="mt-2"
    >

      <app-collapse-item
        v-for="( data,index) in options.qandA"
        :key="index"
        :title="data.question"
      >
      <!-- {{`${String(data.ans).replace('\n', '<br>')}`}}  -->
      <div style="white-space: pre-line" v-html="$t(data.ans)"></div>
      </app-collapse-item>

    </app-collapse>

    <!--/ collapse -->
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BAvatar,
    AppCollapseItem,
    AppCollapse,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
